import React from "react";

const footer = (props) => (
  <footer className="footer">
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          {new Date().getFullYear()} © NATCA. v 2.3.6
        </div>
      </div>
    </div>
  </footer>
);

export default footer;
